import React, { useState } from 'react';
import { TextInput } from 'carbon-components-react';

const CustomTextInput = props => {
  const [value, setValue] = useState(props.formData);
  let label = props.schema.title;

  if (props.required) label += ' *';

  const onChange = event => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  return (
    <div style={{ marginTop: 25 }}>
      <TextInput
        id={props.idSchema.$id}
        type={props.uiSchema['ui:options'] || 'text'}
        labelText={label}
        placeholder={props.schema.placeholder}
        light
        invalid={false}
        invalidText='A valid value is required'
        onChange={onChange}
        value={value || ''}
        disabled={props.schema.readOnly}
        style={{
          background: 'white',
          width: '478px'
        }}
      />
    </div>
  );
};

export default CustomTextInput;
